import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useMutation } from "@tanstack/react-query";
import { getRebateReport, getVerifyInfo } from "../library/api";
import {
  useRecoilState,
  useRecoilValue,
  useResetRecoilState,
  useSetRecoilState,
} from "recoil";
import { verifyInfoState } from "../library/recoil/atoms/verifyInfoState";

const nav = [
  {
    login: false,
    label: "약관 및 정책",
    selected: false,
    icon: false,
    url: "/policy",
  },
  {
    login: false,
    label: "공지사항",
    selected: false,
    icon: false,
    url: "/notice",
  },
  {
    login: false,
    label: "일사서비스란?",
    selected: false,
    icon: true,
    url: "/",
  },
  {
    login: true,
    label: "홈",
    selected: false,
    icon: false,
    url: "/",
  },
  {
    login: true,
    label: "기간별 리포트",
    selected: false,
    icon: false,
    url: "/period-report",
  },
  {
    login: true,
    label: "정산 리포트",
    selected: false,
    icon: false,
    url: "/settlement-report",
  },
  {
    login: true,
    label: "약관 및 정책",
    selected: false,
    icon: false,
    url: "/policy",
  },
  {
    login: true,
    label: "문의하기",
    selected: false,
    icon: false,
    url: "/inquiry",
  },
  {
    login: true,
    label: "공지사항",
    selected: false,
    icon: false,
    url: "/notice",
  },
];
const Header = () => {
  const [verifyInfo, setVerifyInfo] = useRecoilState(verifyInfoState);
  const resetVerifyInfo = useResetRecoilState(verifyInfoState);
  //  const setUserInfo = useSetRecoilState(userInfoState);
  const token = localStorage.getItem("admin_token");

  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [dropdownOpen1, setDropdownOpen1] = useState(false);
  const [login, setLogin] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const dropDownRef = useRef(null);
  const dropDownRef1 = useRef(null);

  // //기본 유저 정보 가져오기
  const { mutate: getVerifyInfoMutate, data: getVerifyInfoData } = useMutation({
    mutationFn: getVerifyInfo,
    mutationKey: ["getVerifyInfo"],
    onSuccess: (data) => {
      setVerifyInfo(data);
      // navigate('/period-report');
    },
    onError: (error) => {
      localStorage.setItem("admin_token", "");
      resetVerifyInfo();
      navigate("/login");
      if (error.response.data.code === 401) {
        alert("세션이 만료 되었습니다 다시 로그인 해주세요");
      }
      throw error;
    },
  });

  useEffect(() => {
    setDropdownOpen(false);
    setMobileMenuOpen(false);

    if (!localStorage.getItem("admin_token")) {
      setLogin(false);
    } else {
      setLogin(true);
    }
  }, [location]);
  useEffect(() => {
    if (!token) {
      return;
    }
    getVerifyInfoMutate();
  }, [location]);
  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownOpen1 && !dropDownRef1?.current?.contains(event.target))
        setDropdownOpen1(false);
    }

    // 마운트 시 document에 이벤트 리스너 추가
    document.addEventListener("mousedown", handleClickOutside);

    // 컴포넌트 언마운트 시 이벤트 리스너 제거
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [dropdownOpen1]);

  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownOpen && !dropDownRef?.current?.contains(event.target))
        setDropdownOpen(false);
    }

    // 마운트 시 document에 이벤트 리스너 추가
    document.addEventListener("mousedown", handleClickOutside);
    // 컴포넌트 언마운트 시 이벤트 리스너 제거
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [dropdownOpen]);

  return (
    <header className="bg-white border-b border-gray-200 drop-shadow">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
        <div className="flex items-center h-full">
          <a href="/">
            <img src="./assets/ilsa_logo.png" alt="ilsa logo" className="h-8" />
          </a>
          <nav className="hidden lg:flex space-x-6 ml-12 h-full">
            {nav.map((e, i) =>
              e.login === login ? (
                e.icon ? (
                  <a
                    key={i}
                    href="https://ilsaram.co.kr/"
                    target="_blank"
                    className={`box-border cursor-pointer font-bold text-base h-full flex justify-center items-center hover:text-teal-500`}
                  >
                    일사서비스란?
                    <img className="ml-1" src="./assets/move.svg" />
                  </a>
                ) : (
                  <a
                    key={i}
                    onClick={() => {
                      navigate(e.url);
                    }}
                    className={`box-border cursor-pointer font-medium text-base h-full flex justify-center  items-center hover:border-b-2 hover:border-teal-500 hover:text-teal-500  ${
                      e.url === location.pathname &&
                      "text-teal-500 border-b-2 border-teal-500"
                    }`}
                  >
                    {e.label}
                  </a>
                )
              ) : (
                ""
              )
            )}
          </nav>
        </div>

        {login ? (
          <>
            <div
              className="hidden xl:flex items-center space-x-6"
              x-data="{ dropdownOpen: false }"
            >
              <p
                className="text-sm cursor-pointer"
                onClick={(event) => {
                  event.preventDefault();
                  setDropdownOpen(!dropdownOpen);
                }}
              >
                파트너 ID{" "}
                <span className="text-teal-500 ml-1 underline underline-offset-2">
                  {verifyInfo?.partners_cd}
                </span>
              </p>
              <div className="relative" ref={dropDownRef}>
                {dropdownOpen && (
                  <div className="absolute right-0 mt-2 w-[130px] bg-white rounded-md shadow-lg z-10 flex flex-col justify-center items-center">
                    <a
                      onClick={(event) => {
                        navigate("/payment");
                      }}
                      className="block px-4 py-4 text-sm hover:text-teal-500"
                    >
                      결제정보 변경
                    </a>
                    <a
                      onClick={() => {
                        navigate("/withdraw");
                        // setDropdownOpen(false);
                      }}
                      className="block px-4 py-4 text-sm hover:text-teal-500"
                    >
                      회원탈퇴
                    </a>
                    <a
                      onClick={(event) => {
                        event.preventDefault();
                        navigate("/");
                        //  setDropdownOpen(false);
                        localStorage.setItem("admin_token", "");
                        setVerifyInfo({});
                      }}
                      className="block px-4 py-4 text-sm hover:text-teal-500"
                    >
                      로그아웃
                    </a>
                  </div>
                )}
              </div>
            </div>

            <div className="flex gap-x-4 xl:hidden" ref={dropDownRef1}>
              <button
                className="outline-none "
                onClick={(event) => {
                  event.preventDefault();
                  setDropdownOpen1(!dropdownOpen1);
                }}
              >
                <img src="./assets/user.svg" />
              </button>

              <button className="lg:hidden" onClick={(event) => {}}>
                <svg
                  className="w-6 h-6"
                  onClick={() => {
                    setDropdownOpen1(false);
                    setMobileMenuOpen(!mobileMenuOpen);
                  }}
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M4 6h16M4 12h16m-7 6h7"
                  ></path>
                </svg>
              </button>

              {dropdownOpen1 && (
                <div className="xl:hidden top-[63px] absolute lg:right-[4%] md:right-[8%] right-[5%] w-[190px] bg-white rounded-md shadow-lg z-10 flex flex-col justify-center items-center">
                  <p className="block px-4 py-4 text-sm">
                    ID{" "}
                    <span className="text-teal-500 ml-1 underline underline-offset-2">
                      {verifyInfo?.partners_cd}
                    </span>
                  </p>

                  <a
                    onClick={(event) => {
                      navigate("/payment");
                      setDropdownOpen1(false);
                    }}
                    className="block px-4 py-4 text-sm hover:text-teal-500"
                  >
                    결제정보 변경
                  </a>
                  <a
                    onClick={() => {
                      navigate("/withdraw");
                      setDropdownOpen1(false);
                    }}
                    className="block px-4 py-4 text-sm hover:text-teal-500"
                  >
                    회원탈퇴
                  </a>
                  <a
                    onClick={(event) => {
                      event.preventDefault();
                      //setLogin(false);
                      navigate("/");
                      localStorage.setItem("admin_token", "");
                      setVerifyInfo({});
                      setDropdownOpen1(false);
                    }}
                    className="block px-4 py-4 text-sm hover:text-teal-500"
                  >
                    로그아웃
                  </a>
                </div>
              )}
            </div>
          </>
        ) : (
          <>
            <div className="hidden lg:flex items-center space-x-4">
              <button
                className="font-bold text-sm hover:text-teal-500"
                style={{
                  color: location.pathname === "/login" ? "#14b8a6" : "#000",
                }}
                onClick={() => navigate("/login")}
              >
                로그인
              </button>
              <button
                className="font-bold text-sm hover:text-teal-500"
                style={{
                  color: location.pathname === "/signUp" ? "#14b8a6" : "#000",
                }}
                onClick={() => navigate("/signUp")}
              >
                회원가입
              </button>
              <button
                onClick={() => {
                  setMobileMenuOpen(!mobileMenuOpen);
                }}
                className="lg:hidden"
              >
                <svg
                  className="w-6 h-6"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M4 6h16M4 12h16m-7 6h7"
                  ></path>
                </svg>
              </button>
            </div>
            <div className="flex gap-x-4 lg:hidden">
              <div className="lg:hidden flex items-center space-x-2 whitespace-nowrap">
                <button
                  className="w-full text-left block px-1 py-2 rounded-md text-base font-medium hover:text-teal-500"
                  style={{
                    color: location.pathname === "/login" ? "#14b8a6" : "#000",
                  }}
                  onClick={() => navigate("/login")}
                >
                  로그인
                </button>
                <button
                  className="w-full text-left block px-1 py-2 rounded-md text-base font-medium hover:text-teal-500"
                  style={{
                    color: location.pathname === "/signUp" ? "#14b8a6" : "#000",
                  }}
                  onClick={() => navigate("/signUp")}
                >
                  회원가입
                </button>
              </div>
              <button
                onClick={() => {
                  setMobileMenuOpen(!mobileMenuOpen);
                }}
                className="lg:hidden"
              >
                <svg
                  className="w-6 h-6"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M4 6h16M4 12h16m-7 6h7"
                  ></path>
                </svg>
              </button>
            </div>
          </>
        )}
      </div>
      {mobileMenuOpen && (
        <div className="lg:hidden absolute bg-white w-full z-9999">
          <nav className="px-2 pt-2 pb-3 space-y-1">
            {nav.map((e, i) =>
              e.icon === false && e.login === login ? (
                <a
                  key={i}
                  onClick={() => {
                    navigate(e.url);
                  }}
                  className={`block px-3 py-2 rounded-md text-base font-medium hover:text-teal-500  ${
                    e.url === location.pathname && "text-teal-500"
                  }`}
                >
                  {e.label}
                </a>
              ) : (
                ""
              )
            )}
          </nav>
        </div>
      )}
    </header>
  );
};

export default Header;
